angular.module('profumo.config', [])
    .run(['$rootScope', 'config', function ($rootScope, config) {
        $rootScope.config = config || {};
    }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/config.ts
// module id = 446
// module chunks = 0